import React, { FC, ReactNode } from "react";

interface Props {
  children: ReactNode;
}

/**
 * Pins a page's filter bar to the top of `PageLayout`'s scrolling content, the way the title above
 * it stays put. It must sit in the same column as the list it filters — a sticky element never
 * leaves its parent's box.
 *
 * From `md` up only: a phone's filters unfold to most of the screen and would cover the list. The
 * background is the page grey from `AppLayout`, so rows do not show through; `z-20` keeps select
 * dropdowns above them.
 */
export const StickyFilterBar: FC<Props> = ({ children }) => (
  <div className="z-20 bg-[#E8EEF1] md:sticky md:top-0 md:pb-2 md:pt-1">{children}</div>
);
